export default {
  minimal: 2,
  micro: 4,
  small: 8,
  medium: 12,
  regular: 16,
  big: 32,
  large: 64,
  defaultRadius: 8,
  regularRadius: 16,
  bigRadius: 32,
};
